<template>
	<div class="page">
		<el-image src="https://file.aavisa.com/browser-upload-file/497bca71-a052-4770-a516-1a8b75caea9a.jpg" fit="fill"
			style="width: 100%;"></el-image>
		<div class="box">

			<div class="title">
				<p>关于我们</p>
			</div>

			<div class="tt">
				<p>关于我们虎翼掌上签属于深圳虎翼国际旅行社有限公司旗下品牌，由虎翼创始人张伟先生创办，是国内最有影响力的专业从事出国服务的权成服务机构之一，自成立以来一直专注于B2B出国签证。</p>
				<p>公司目前提供全球主流国家的各种签证咨询与办理服务，擅长的签证产品包括旅游、商务、探亲、访友、访问、留学等非移民类型签证，提供行程制作，机酒预定，酒店预定等一系列服务，为客户提供全面、便捷、体贴的“一站式”签证服务。</p>
				<p>虎翼掌上签拥有一支经验丰富的专业化签证服务团队,深谙各国签证的政策原则以及最新动向，可以根据申请人自身情况为客户策划详尽有效的签证申请方案,提供签证申请流程的全程指导，协助申请人准备签证申请材料和文件，提供专业化的模拟面试培训，快速为客户提供签证代取、代送业务，20年以来签证成功通过率接近100%。
				</p>
				<p>虎翼掌上签在长期的发展过程中，还积累了深厚的国际社会关系资源，与多国领馆长期保持良好合作关系，可为客户提供热门国家签证加急服务。</p>
				<p>虎翼掌上签，高性价比的手机签证同业平台！</p>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang='less' scoped>
	.page {
		text-align: left;
		background-color: #fff;
		.box {
			overflow: hidden;
			width: 75rem;
			height: 49.375rem;
			margin: 0rem auto 0rem;
			
		}

		&>div {}

		.title {
			color: #333333;
			font-size: 2rem;
			text-align: center;
			font-weight: 600;
			margin-top: 4.625rem;
			margin-bottom: 3.375rem;
		}

		.tt {
			padding: 0 3.125rem;
			margin-bottom: 1.25rem;

			&>p {
				margin-bottom: 2.275rem;
				margin-top: 0;
				line-height: 2.2rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/aboutus/aboutus.vue